<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>


<a (click)="activeModal.close()" class="pull-right">&times {{ "close" | translate }} </a>

<div class="text-center">
    <img [src]="currentImage"/>
</div>